<template>
  <div class="mainContainer" :style="loginImage">
    <TopHeader :pageTitle="pageHead" />
    <!----------------Main Page------------------------------------------>
    <div class="pageContainer shadow-lg rounded" fluid="sm">
      <div class="page-content">
        <SecondaryHeader />
        <!---------------Tab Container---------------------->
        <b-card no-body :class="bodyPanel">
          <div v-if="notabvisible">
            <h4 class="disclaimerText">
              You do not have any access to view these tabs.
            </h4>
          </div>
          <div v-else>
            <b-tabs card>
              <!-- <userInfo v-if="this.$route.path.includes('sectorvaluations')"/> -->
              <b-tab
                :active="value.activeToggle"
                v-for="(value, index) in valuationChildren"
                v-bind:key="index"
                :title="value.objectname"
                :title-link-class="{'d-none':!value.is_visible}"
                @click="
                  !value.activeToggle
                    ? navigateTab(`${value.objectname}`)
                    : () => {}
                "
              >
              </b-tab>
              <div class="col-12 p-0 h-100">
                <router-view></router-view>
              </div>
            </b-tabs>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
//Import Packages
import { mapActions, mapGetters } from "vuex";
import AppConstants from "@/appConstants.js";
// Import Images
import bgImage from "@/assets/img/dbTiles/BG.png";
import TopHeader from "@/components/BaseFiles/TopHeader.vue";
import SecondaryHeader from "@/components/BaseFiles/SecondHeader.vue";
// import userInfo from "../userInfo/userInfo.vue";

export default {
  name: "Valuation",
  components: {
    TopHeader,
    SecondaryHeader,
    // userInfo,
  },
  data() {
    return {
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      pageHead: `${AppConstants.VALUATION}`,
      component: [],
      bodyPanel: "bodyPanelOpen",
      notabvisible: false
    };
  },
  computed: {
    ...mapGetters({
      valuation: "valuation",
    }),
    valuationChildren() {
      return this.valuation.child;
    },
  },
  methods: {
    ...mapActions(["getChartDataById"]),
    onClickChild(value) {
      if (value) {
        this.bodyPanel = "bodyPanel";
      } else {
        this.bodyPanel = "bodyPanelOpen";
      }
    },
    getChildChartInfoByName(tabName) {
      let filterChart = this.valuationChildren.filter((item) => {
        if (tabName === item.objectname) {
          item.activeToggle = true;
          return true;
        } else {
          item.activeToggle = false;
        }
      });
      return filterChart[0];
    },
    navigateTab(tabName) {
      let chartinfo = this.getChildChartInfoByName(tabName);
      let chartName = chartinfo.objectname;
      let path = `/Valuation/${chartName.toLowerCase().replace(/ /g, "")}`;
      let navigate = true;
      this.getChartDataById({
        id: chartinfo.chartId,
        chartName: chartName,
        path: path,
        navigate: navigate,
      });
    },
  },
  mounted() {
    if (this.$route.path == "/Valuation" || this.$route.path == "/Valuation/") {
      let chartinfo = null
      for(let [ii,dd] of this.valuationChildren.entries()){
        if(dd.is_visible){
          chartinfo = dd
          chartinfo.activeToggle = true
          break;
        }
      }
      if(chartinfo == null) { 
        this.notabvisible = true 
        return
      }
     
      let chartName = chartinfo.objectname;
      let path = `/Valuation/${chartName.toLowerCase().replace(/ /g, "")}`;
      this.getChartDataById({
        id: chartinfo.chartId,
        chartName: chartName,
        path: path,
        navigate: true,
      });
      //this.$router.push({ name: chartName.replace(/ /g, "") });
    }
    else {
      for(let [ii,dd] of this.valuationChildren.entries()){
        if(this.$route.path == `/Valuation/${dd.objectname.toLowerCase().replace(/ /g, "")}`){
          if(!dd.is_visible){
            this.notabvisible = true 
            return
          }
        }
      }
    }
  },
};
</script>
